/* VAULT - core global JS */
(function(){
  'use strict';
  var V = window.Vault = window.Vault || {};
  V.$ = function(s,r){ return (r||document).querySelector(s); };
  V.$$ = function(s,r){ return Array.from((r||document).querySelectorAll(s)); };
  V.on = function(el,ev,fn,opt){ if(el) el.addEventListener(ev,fn,opt||false); };
  V.formatMoney = function(cents){
    var n = Number(cents);
    if(isNaN(n)) n = 0;
    var amount = n / 100;
    var cur = (window.VAULT && VAULT.currency && VAULT.currency.active) || 'AUD';
    try { return new Intl.NumberFormat('en-AU',{style:'currency',currency:cur}).format(amount); }
    catch(e){ return '$' + amount.toFixed(2); }
  };
  V.debounce = function(fn,wait){
    var t; return function(){ var ctx=this,a=arguments; clearTimeout(t); t=setTimeout(function(){fn.apply(ctx,a);},wait); };
  };
  V.emit = function(n,d){ document.dispatchEvent(new CustomEvent(n,{detail:d||{}})); };
  V.toast = function(msg){
    var t = V.$('#toast'); if(!t) return;
    var span = t.querySelector('[data-toast-message]');
    if(span) span.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(V._toastT);
    V._toastT = setTimeout(function(){ t.classList.remove('is-visible'); }, 2400);
  };

  /* ---------------------------------------------------------------------------
     Focus management for drawers and modals.

     Previously the menu drawer, cart drawer and search modal were only moved
     off-screen with transform (and opacity for the modal) while carrying
     aria-hidden="true". Off-screen is not hidden: every link and button inside
     stayed in the tab order, so a keyboard user tabbing across the page fell into
     a panel they could not see and could not escape. aria-hidden on a container
     holding focusable elements is also an ARIA violation in its own right.

     The CSS now applies visibility:hidden when closed, which removes the contents
     from the tab order. These helpers add the other half: move focus into the
     panel on open, keep Tab cycling inside it, and return focus to whatever
     opened it on close.
  --------------------------------------------------------------------------- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  V.focusables = function(container){
    if(!container) return [];
    return V.$$(FOCUSABLE, container).filter(function(el){
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  };

  V._lastFocus = null;

  V.trapFocus = function(container){
    if(!container) return;
    V._lastFocus = document.activeElement;
    // Defer so the panel has finished becoming visible before we measure it.
    setTimeout(function(){
      var items = V.focusables(container);
      (items[0] || container).focus();
    }, 60);

    container._trapHandler = function(e){
      if(e.key !== 'Tab') return;
      var items = V.focusables(container);
      if(!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if(e.shiftKey && document.activeElement === first){
        e.preventDefault(); last.focus();
      } else if(!e.shiftKey && document.activeElement === last){
        e.preventDefault(); first.focus();
      }
    };
    container.addEventListener('keydown', container._trapHandler);
  };

  V.releaseFocus = function(container){
    if(container && container._trapHandler){
      container.removeEventListener('keydown', container._trapHandler);
      container._trapHandler = null;
    }
    if(V._lastFocus && typeof V._lastFocus.focus === 'function'){
      V._lastFocus.focus();
      V._lastFocus = null;
    }
  };

  /* Header scroll shadow */
  var header = V.$('.site-header');
  if(header){
    var onScroll = function(){
      if(window.scrollY > 4) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
  }

  /* Mobile menu drawer */
  var menuDrawer = V.$('#menu-drawer');
  var drawerScrim = V.$('[data-drawer-scrim]');
  function openMenu(){
    if(!menuDrawer || menuDrawer.classList.contains('is-open')) return;
    menuDrawer.classList.add('is-open');
    menuDrawer.setAttribute('aria-hidden','false');
    // Same dialog semantics the cart drawer and search modal already carry: focus
    // is trapped while open, so assistive tech must be told the rest is inert.
    menuDrawer.setAttribute('role','dialog');
    menuDrawer.setAttribute('aria-modal','true');
    V.$$('[data-drawer-open]').forEach(function(b){ b.setAttribute('aria-expanded','true'); });
    if(drawerScrim){ drawerScrim.hidden = false; drawerScrim.classList.add('is-open'); }
    document.body.classList.add('no-scroll');
    V.trapFocus(menuDrawer);
  }
  function closeMenu(){
    if(!menuDrawer || !menuDrawer.classList.contains('is-open')) return;
    menuDrawer.classList.remove('is-open');
    menuDrawer.setAttribute('aria-hidden','true');
    menuDrawer.removeAttribute('role');
    menuDrawer.removeAttribute('aria-modal');
    V.$$('[data-drawer-open]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
    if(drawerScrim){ drawerScrim.classList.remove('is-open'); setTimeout(function(){drawerScrim.hidden=true;},300); }
    document.body.classList.remove('no-scroll');
    V.releaseFocus(menuDrawer);
  }
  /* Close the mobile drawer if the viewport grows past the point where the desktop
     nav takes over. Verified in Chromium: opening the drawer at 390px then resizing
     to 1440px left it open with document.body still carrying .no-scroll — so a
     tablet rotated from portrait to landscape, or any desktop window resize, ended
     up with the mobile menu on screen over a page that could not be scrolled.
     990px matches the breakpoint where .site-header__nav appears. */
  var desktopNav = window.matchMedia('(min-width: 990px)');
  var closeMenuOnDesktop = function(e){ if((e.matches !== undefined ? e.matches : desktopNav.matches)) closeMenu(); };
  if(desktopNav.addEventListener) desktopNav.addEventListener('change', closeMenuOnDesktop);
  else if(desktopNav.addListener) desktopNav.addListener(closeMenuOnDesktop);

  V.$$('[data-drawer-open]').forEach(function(btn){ btn.setAttribute('aria-expanded','false'); V.on(btn,'click',openMenu); });
  V.$$('[data-drawer-close]').forEach(function(btn){ V.on(btn,'click',closeMenu); });
  V.on(drawerScrim,'click',closeMenu);
  /* Mobile submenu toggle */
  V.$$('[data-submenu-toggle]').forEach(function(btn){
    V.on(btn,'click',function(){
      var sub = btn.nextElementSibling;
      if(!sub) return;
      var open = sub.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Footer accordion: closed on mobile (clean), open on desktop (synced with inline script and on resize) */
  var footerCols = V.$$('.site-footer__col');
  if (footerCols.length) {
    var syncFooter = function(){
      var isMobile = window.matchMedia('(max-width: 640px)').matches;
      footerCols.forEach(function(col){
        var summary = col.querySelector('.site-footer__col-title');
        if (isMobile) {
          // On mobile, only force-collapse if user hasn't manually opened it
          if (!col.dataset.userToggled) col.open = false;
          if (summary) { summary.removeAttribute('tabindex'); summary.removeAttribute('aria-disabled'); }
        } else {
          col.open = true;
          // On desktop the click handler below suppresses toggling, which left the
          // <summary> focusable but inert — a keyboard user tabbed onto a control
          // that did nothing. Take it out of the tab order while it is non-functional
          // (its text stays readable and exposed to screen readers).
          if (summary) { summary.setAttribute('tabindex', '-1'); summary.setAttribute('aria-disabled', 'true'); }
        }
      });
    };
    footerCols.forEach(function(col){
      // Track user-initiated toggles on mobile so resize doesn't reset their state
      col.addEventListener('toggle', function(){
        if (window.matchMedia('(max-width: 640px)').matches) {
          col.dataset.userToggled = '1';
        }
      });
      // Prevent click on summary from toggling on desktop
      var summary = col.querySelector('.site-footer__col-title');
      if (summary) {
        summary.addEventListener('click', function(e){
          if (!window.matchMedia('(max-width: 640px)').matches) e.preventDefault();
        });
      }
    });
    window.addEventListener('resize', V.debounce(syncFooter, 150));
    syncFooter(); // Run on initial load too, not just on resize
  }

  /* Cart drawer triggers (handled in cart.js for state) */
  // The cart trigger is an <a href="/cart"> so it still works with no JS. Here we
  // intercept the click and open the drawer instead — but only for a plain left
  // click. Cmd/Ctrl/middle-click must keep opening the cart page in a new tab,
  // which is behaviour people rely on and which preventDefault would silently
  // break.
  V.$$('[data-cart-open]').forEach(function(btn){
    V.on(btn,'click',function(e){
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      V.emit('cart:open');
    });
  });
  V.$$('[data-cart-close]').forEach(function(btn){ V.on(btn,'click',function(){ V.emit('cart:close'); }); });

  /* Search modal */
  // Anchor to the search page; intercept the plain click to open the overlay.
  // Modifier and middle clicks pass through so "open search in a new tab" still works.
  V.$$('[data-search-open]').forEach(function(btn){
    V.on(btn,'click',function(e){
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      V.emit('search:open');
    });
  });
  V.$$('[data-search-close]').forEach(function(btn){ V.on(btn,'click',function(){ V.emit('search:close'); }); });

  /* ESC closes drawers/modals */
  document.addEventListener('keydown',function(e){
    if(e.key !== 'Escape') return;
    closeMenu();
    V.emit('cart:close');
    V.emit('search:close');
  });

  /* Mega menu — hover for mouse, click for touch laptops, keyboard for a11y */
  var megaTriggers = V.$$('[data-mega-trigger]');
  var megas = V.$$('.mega');
  var megaTimeout;
  var openMegaIdx = -1;
  function closeAllMegas(){
    megas.forEach(function(m,i){
      m.classList.remove('is-open');
      var t = megaTriggers[i];
      var l = t && t.querySelector('.nav-link');
      if(l) l.setAttribute('aria-expanded','false');
    });
    openMegaIdx = -1;
  }
  megaTriggers.forEach(function(trig, idx){
    var link = trig.querySelector('.nav-link');
    var mega = megas[idx];
    if(!mega) return;
    if(link){ link.setAttribute('aria-haspopup','true'); link.setAttribute('aria-expanded','false'); }
    function open(){
      clearTimeout(megaTimeout);
      // Close any other open mega panel
      megas.forEach(function(m,i){
        if(i !== idx){
          m.classList.remove('is-open');
          var ll = megaTriggers[i] && megaTriggers[i].querySelector('.nav-link');
          if(ll) ll.setAttribute('aria-expanded','false');
        }
      });
      mega.classList.add('is-open');
      if(link) link.setAttribute('aria-expanded','true');
      openMegaIdx = idx;
    }
    function close(){
      megaTimeout = setTimeout(function(){
        mega.classList.remove('is-open');
        if(link) link.setAttribute('aria-expanded','false');
        if(openMegaIdx === idx) openMegaIdx = -1;
      }, 120);
    }
    // Mouse
    V.on(trig,'mouseenter',open);
    V.on(trig,'mouseleave',close);
    V.on(mega,'mouseenter',function(){clearTimeout(megaTimeout);});
    V.on(mega,'mouseleave',close);
    // Touch / click — toggle, and stop the link from navigating on the first tap
    if(link){
      V.on(link,'click',function(e){
        // Only intercept if we're on a touch-primary device or there's submenu content.
        // Allow normal navigation if the user is using a mouse and already saw the hover panel.
        var isTouch = !window.matchMedia('(hover: hover)').matches;
        if(isTouch){
          e.preventDefault();
          if(openMegaIdx === idx) closeAllMegas();
          else open();
        }
      });
      // Keyboard: Enter/Space opens, ArrowDown moves into the panel, Escape closes
      V.on(link,'keydown',function(e){
        if(e.key === 'Enter' || e.key === ' '){
          e.preventDefault();
          if(openMegaIdx === idx) closeAllMegas();
          else { open(); var firstLink = mega.querySelector('a'); if(firstLink) setTimeout(function(){firstLink.focus();}, 80); }
        } else if(e.key === 'ArrowDown'){
          e.preventDefault();
          open();
          var firstLink = mega.querySelector('a');
          if(firstLink) setTimeout(function(){firstLink.focus();}, 80);
        } else if(e.key === 'Escape'){
          closeAllMegas();
        }
      });
    }
    // Escape inside the panel returns focus to the trigger
    V.on(mega,'keydown',function(e){
      if(e.key === 'Escape'){
        closeAllMegas();
        if(link) link.focus();
      }
    });
  });
  // Click outside closes any open mega panel
  document.addEventListener('click', function(e){
    if(openMegaIdx === -1) return;
    if(e.target.closest('[data-mega-trigger]') || e.target.closest('.mega')) return;
    closeAllMegas();
  });

  /* Reveal on scroll */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        }
      });
    },{threshold:0.1, rootMargin:'0px 0px -10% 0px'});
    V.$$('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    V.$$('.reveal').forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* The mobile quick-add scroll-reveal block that used to live here has been
     removed along with the hover-only quick-add it existed to work around. The
     card action is now always visible, so there is nothing to reveal — roughly
     60 lines of scroll listeners, IntersectionObservers and media-query teardown
     deleted rather than maintained. */

  /* Qty controls (delegated) */
  document.addEventListener('click',function(e){
    var dec = e.target.closest('[data-qty-decrement]');
    var inc = e.target.closest('[data-qty-increment]');
    if(!dec && !inc) return;
    var wrap = (dec||inc).closest('.qty-control');
    if(!wrap) return;
    var input = wrap.querySelector('input');
    if(!input) return;
    var v = parseInt(input.value,10) || 1;
    var min = parseInt(input.min,10);
    if(isNaN(min)) min = 0;
    var max = parseInt(input.max,10);
    if(dec) v = Math.max(min, v-1);
    if(inc) v = (!isNaN(max) ? Math.min(max, v+1) : v+1);
    input.value = v;
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* Sticky mobile ATC */
  var mainAtc = V.$('[data-main-atc]');
  var stickyAtc = V.$('[data-sticky-atc]');
  if(mainAtc && stickyAtc && 'IntersectionObserver' in window){
 var atcIo = null;
 var atcResizeTimer = null;
 function stickyAtcApply(en){
 stickyAtc.classList.toggle('is-visible', !(en.isIntersecting && en.intersectionRatio >= 0.5));
 }
 /* The bar exists so a purchase control is always within reach. The previous
 observer watched the real button against the whole viewport, so it hid the bar
 the moment any sliver of that button intersected - including the sliver sitting
 under the sticky header and the part sitting behind the bar itself. Measured at
 390x844: from scrollY 960 to 1043 the bar was hidden while only 43px of the
 button showed at the very top edge, under the header, so there was no usable
 control on screen at all; and crossing that band in either direction slid the
 bar out and back in. That is what read as flicker.
 The root is now shrunk to the band a shopper can actually use, below the header
 and above the bar, and the bar only hides once half the button is inside it, so
 a few pixels of scroll can no longer toggle it. Both insets are measured from
 the live elements and the observer is rebuilt on resize and rotation, so a
 collapsing iOS toolbar or a turned phone cannot leave a stale margin behind. */
 function buildAtcObserver(){
 if(atcIo) atcIo.disconnect();
 var wrap = V.$('.site-header-wrap');
 var topInset = wrap ? Math.round(wrap.getBoundingClientRect().height) : 0;
 var bottomInset = Math.round(stickyAtc.offsetHeight) || 64;
 atcIo = new IntersectionObserver(function(entries){ entries.forEach(stickyAtcApply); }, {
 threshold: [0, 0.5, 1],
 rootMargin: '-' + topInset + 'px 0px -' + bottomInset + 'px 0px'
 });
 atcIo.observe(mainAtc);
 }
 function rebuildAtcObserverSoon(delay){
 clearTimeout(atcResizeTimer);
 atcResizeTimer = setTimeout(buildAtcObserver, delay);
 }
 buildAtcObserver();
 window.addEventListener('resize', function(){ rebuildAtcObserverSoon(200); }, {passive:true});
 window.addEventListener('orientationchange', function(){ rebuildAtcObserverSoon(350); });
 var stickyBtn = V.$('[data-sticky-atc-btn]');
if(stickyBtn){
/* Diverting to the variant picker exists to stop wrong-variant orders on
multi-variant products and it should stay. Two things about it were wrong.
It fired even for a shopper who had already chosen, so a deliberate tap on
Add to cart threw them back up the page; and it scrolled in silence, which
makes a primary CTA feel broken. It now diverts only until a choice has
actually been made, and it says why. */
var variantChosen = false;
document.addEventListener('click', function(e){
if(e.target.closest && e.target.closest('[data-variant-pill]')) variantChosen = true;
}, true);
V.on(stickyBtn,'click',function(){
var form = V.$('.product-form');
if(!form) return;
var hasVariants = stickyBtn.getAttribute('data-product-has-variants') === 'true';
var variantPicker = V.$('.product-options', form);
if(hasVariants && variantPicker && !variantChosen){
var picker = variantPicker.getBoundingClientRect();
/* Only divert when the picker has scrolled off the top. If it is still on
screen below, the shopper can see it and the tap should add. */
if(picker.top < 0){
window.scrollTo({ top: window.scrollY + picker.top - 100, behavior: 'smooth' });
var optName = variantPicker.querySelector('.product-option__name');
var optLabel = optName ? optName.textContent.trim() : '';
if(optLabel.toLowerCase() === 'title') optLabel = '';
if(V.toast) V.toast(optLabel ? 'Choose a ' + optLabel.toLowerCase() + ' first' : 'Choose an option first');
return;
}
}
var submitBtn = form.querySelector('[type="submit"]');
if(submitBtn) submitBtn.click();
});
}
 }

  /* Product gallery */
  var gallerySlides = V.$$('[data-gallery-slides] [data-media-id]');
  var galleryThumbs = V.$$('[data-thumb]');
  var galleryCurrent = V.$('[data-gallery-current]');
  function showSlide(idx){
    gallerySlides.forEach(function(s,i){ s.classList.toggle('is-active', i===idx); });
    galleryThumbs.forEach(function(t,i){ t.classList.toggle('is-active', i===idx); });
    if(galleryCurrent) galleryCurrent.textContent = (idx+1);
  }
  galleryThumbs.forEach(function(t,i){ V.on(t,'click',function(){ showSlide(i); }); });
  V.on(V.$('[data-gallery-prev]'),'click',function(){
    var active = gallerySlides.findIndex(function(s){return s.classList.contains('is-active');});
    showSlide((active - 1 + gallerySlides.length) % gallerySlides.length);
  });
  V.on(V.$('[data-gallery-next]'),'click',function(){
    var active = gallerySlides.findIndex(function(s){return s.classList.contains('is-active');});
    showSlide((active + 1) % gallerySlides.length);
  });
  // Touch swipe on the gallery main area
  var gallerySlidesWrap = V.$('[data-gallery-slides]');
  if(gallerySlidesWrap && gallerySlides.length > 1){
    var touchStartX = 0, touchStartY = 0, touchActive = false;
    gallerySlidesWrap.addEventListener('touchstart', function(e){
      if(!e.touches || !e.touches[0]) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchActive = true;
    }, {passive: true});
    gallerySlidesWrap.addEventListener('touchend', function(e){
      if(!touchActive || !e.changedTouches || !e.changedTouches[0]) return;
      touchActive = false;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      // Only register horizontal swipes; ignore vertical scrolls
      if(Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var active = gallerySlides.findIndex(function(s){return s.classList.contains('is-active');});
      if(dx < 0) showSlide((active + 1) % gallerySlides.length);
      else showSlide((active - 1 + gallerySlides.length) % gallerySlides.length);
    }, {passive: true});
  }

  /* Countdown */
  V.$$('[data-countdown]').forEach(function(el){
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if(isNaN(target)) return;
    var days = el.querySelector('[data-cd-days]');
    var hours = el.querySelector('[data-cd-hours]');
    var mins = el.querySelector('[data-cd-mins]');
    var secs = el.querySelector('[data-cd-secs]');
    function pad(n){return n<10?'0'+n:''+n;}
    var intervalId = null;
    function tick(){
      var now = Date.now();
      var diff = Math.max(0, target - now);
      var d = Math.floor(diff/86400000);
      var h = Math.floor((diff%86400000)/3600000);
      var m = Math.floor((diff%3600000)/60000);
      var s = Math.floor((diff%60000)/1000);
      if(days) days.textContent = pad(d);
      if(hours) hours.textContent = pad(h);
      if(mins) mins.textContent = pad(m);
      if(secs) secs.textContent = pad(s);
      if(diff === 0 && intervalId !== null){
        clearInterval(intervalId);
        intervalId = null;
        el.classList.add('is-expired');
      }
    }
    tick();
    intervalId = setInterval(tick, 1000);
  });

  /* Cart count bump animation.

     This used to re-set b.hidden and b.textContent as well — the exact same values
     cart.js has already written in renderCart(), which is the only place that emits
     cart:updated. Two files writing the same badge from the same source is a drift
     risk with no benefit, so this now does only the part it uniquely owns. */
  document.addEventListener('cart:updated',function(){
    V.$$('[data-cart-count]').forEach(function(b){
      b.classList.add('is-bumped');
      setTimeout(function(){ b.classList.remove('is-bumped'); }, 400);
    });
  });

  /* Hide the reviews section when Judge.me has no reviews to show.

     With zero reviews the section still rendered a heading, an empty rating pill
     and a "Read all reviews" button leading nowhere — a trust claim with no
     evidence behind it. Judge.me injects asynchronously, so this waits, then
     checks for real review content and removes the section if none arrived.

     Fails OPEN: if this never runs, the section stays visible. Hiding genuine
     reviews would be the worse error. */
  (function(){
    var sec = V.$('[data-reviews-section]');
    if(!sec) return;
    var tries = 0;
    var check = function(){
      // Any of these means Judge.me rendered something real.
      var hasContent = sec.querySelector(
        '.jdgm-rev, .jdgm-carousel-item, .jdgm-all-reviews__body .jdgm-rev-widg__reviews > *'
      );
      var count = sec.querySelector('.jdgm-all-reviews-rating-wrapper__number, .jdgm-prev-badge__text');
      var n = count ? parseInt((count.textContent || '').replace(/[^0-9]/g, ''), 10) : NaN;
      if(hasContent || (!isNaN(n) && n > 0)){ return; }          // real reviews — leave it
      if(++tries < 20){ setTimeout(check, 400); return; }        // give the app 8s
      sec.setAttribute('hidden', '');                             // nothing arrived
    };
    setTimeout(check, 1200);
  })();

  /* Product recommendations fetch */
  V.$$('[data-product-recommendations]').forEach(function(el){
    var url = el.getAttribute('data-url');
    if(!url) return;
    // Reveal the section only once products actually arrive. Previously the
    // heading was already on the page and simply sat above an empty div when
    // Shopify had no recommendations to return.
    var host = el.closest('.recommendations-async');
    fetch(url)
      .then(function(r){ return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.products-row, .products-grid');
        if(inner && inner.children.length){
          el.replaceChildren(inner);
          if(host) host.classList.remove('is-empty');
        } else if(host){
          host.remove();
        }
      })
      .catch(function(){ if(host) host.remove(); });
  });

  /* ---------------------------------------------------------------------------
     Recently viewed.

     Records product handles locally as the shopper browses, then rebuilds the row
     by fetching live cards. Storage is capped, corrupt data is discarded rather
     than thrown, and the section removes itself when there is nothing to show.
  --------------------------------------------------------------------------- */
  (function(){
    var KEY = 'vault:recently-viewed';
    var MAX = 12;

    function read(){
      try {
        var raw = window.localStorage.getItem(KEY);
        if(!raw) return [];
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter(function(h){ return typeof h === 'string' && h; }) : [];
      } catch(e){
        // Private browsing, disabled storage, or corrupt JSON. Degrade silently —
        // this is an enhancement, not something worth breaking the page over.
        return [];
      }
    }

    function write(list){
      try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch(e){}
    }

    // Record the current product.
    var handleMeta = document.querySelector('[data-current-product-handle]');
    if(handleMeta){
      var handle = handleMeta.getAttribute('data-current-product-handle');
      if(handle){
        var list = read().filter(function(h){ return h !== handle; });
        list.unshift(handle);
        write(list);
      }
    }

    var host = V.$('[data-recently-viewed]');
    if(!host) return;
    var listEl = host.querySelector('[data-recently-viewed-list]');
    if(!listEl) return;

    var exclude = host.getAttribute('data-exclude') || '';
    var limit = parseInt(host.getAttribute('data-limit'), 10) || 4;
    // Fetch a few extra so sold-out products (which render no card) don't leave the row short.
    var handles = read().filter(function(h){ return h !== exclude; }).slice(0, limit + 4);

    if(!handles.length){ host.remove(); return; }

    function fetchCard(h){
      return fetch('/products/' + encodeURIComponent(h) + '?section_id=product-card-fragment', {
          headers: {'X-Requested-With':'XMLHttpRequest'}
        })
        .then(function(r){ return r.ok ? r.text() : null; })
        .then(function(html){
          if(!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          // Deleted or unpublished products return markup with no card. Sold-out
          // products return a marker instead: hidden for now, kept for restock.
          return doc.querySelector('.product-card') || (doc.querySelector('[data-card-unavailable]') ? 'unavailable' : null);
        })
        .catch(function(){ return null; });
    }

    Promise.all(handles.map(fetchCard)).then(function(cards){
      var live = cards.filter(function(c){ return c && c !== 'unavailable'; }).slice(0, limit);
      if(!live.length){ host.remove(); return; }
      live.forEach(function(card){ listEl.appendChild(card); });
      host.classList.remove('is-empty');

      // Drop any handle that no longer resolves, so a deleted product does not
      // keep costing a failed request on every page view.
      var dead = handles.filter(function(h, i){ return cards[i] === null; });
      if(dead.length){
        write(read().filter(function(h){ return dead.indexOf(h) === -1; }));
      }

      var clearBtn = host.querySelector('[data-recently-viewed-clear]');
      if(clearBtn){
        clearBtn.hidden = false;
        V.on(clearBtn, 'click', function(){
          try { window.localStorage.removeItem(KEY); } catch(e){}
          host.remove();
        });
      }
    });
  })();

  /* Confirmation for destructive form submissions (e.g. deleting an address).
     Declarative via data-confirm so no inline handler is needed. */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.getAttribute) return;
    var msg = form.getAttribute('data-confirm');
    if(msg && !window.confirm(msg)) e.preventDefault();
  });

  /* Back-in-stock button.

     Only revealed when Klaviyo's onsite embed has actually loaded, so the store
     never shows a control that cannot do anything. Klaviyo injects asynchronously,
     so this polls briefly rather than checking once on DOMContentLoaded and giving
     up. Gives up cleanly after ~5s and leaves the button hidden. */
  (function(){
    var notifyBtns = V.$$('[data-notify-me]');
    if(!notifyBtns.length) return;

    var tries = 0;
    var reveal = function(){
      // A button with a fallback link is already visible and already works; the
      // only job here is to upgrade it to Klaviyo's form once that is available.
      if(window.klaviyo && typeof window.klaviyo.push === 'function'){
        notifyBtns.forEach(function(btn){ btn.hidden = false; });
        return;
      }
      if(++tries < 25) setTimeout(reveal, 200);
    };
    reveal();

    notifyBtns.forEach(function(btn){
      V.on(btn, 'click', function(){
        var id = btn.getAttribute('data-variant-id');
        if(!window.klaviyo || !id) return;
        try { window.klaviyo.push(['openBackInStockModal', id]); }
        catch(e){ /* Klaviyo present but modal unavailable — fail quiet, not broken. */ }
      });
    });
  })();

  /* Quantity input sanitisation.

     Verified in Chromium against the real markup: the +/- buttons clamp correctly
     (floor holds at 1), but typing directly into the field did not. Entering "-3"
     left -3 in the input and "abc" left it empty. The product form carries
     `novalidate`, so the browser's own min="1" does not stop submission, and the
     cart page posts the same value straight into updates[].

     Clamps on change and blur: non-numeric or below the field's min falls back to
     the min (1), and fractional input is floored. */
  function sanitiseQty(input){
    if(!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if(isNaN(min) || min < 0) min = 1;
    var max = parseInt(input.getAttribute('max'), 10);
    var v = parseInt(input.value, 10);
    if(isNaN(v) || v < min) v = min;
    if(!isNaN(max) && max > 0 && v > max) v = max;
    if(String(v) !== input.value) input.value = v;
  }
  document.addEventListener('change', function(e){
    var el = e.target;
    if(el && el.matches && el.matches('[data-qty-input], .qty-input')) sanitiseQty(el);
  });
  document.addEventListener('blur', function(e){
    var el = e.target;
    if(el && el.matches && el.matches('[data-qty-input], .qty-input')) sanitiseQty(el);
  }, true);

  /* Login / recover-password panel toggle.
     Replaces two inline onclick attributes, which fail under any Content-Security
     Policy that blocks inline script — and which were attached to <a href="#..">
     elements that never actually navigated. Now real buttons, with focus moved to
     the panel that appears so keyboard users are not left behind. */
  V.$$('[data-customer-panel]').forEach(function(btn){
    V.on(btn, 'click', function(){
      var target = btn.getAttribute('data-customer-panel');
      var show = document.getElementById(target);
      var hide = document.getElementById(target === 'login' ? 'recover' : 'login');
      if(!show || !hide) return;
      hide.style.display = 'none';
      show.style.display = 'block';
      var field = show.querySelector('input:not([type="hidden"])');
      if(field) field.focus();
    });
  });

  /* Collection sort dropdown — preserve filters and other params, reset page to 1 */
  V.$$('[data-collection-sort]').forEach(function(select){
    V.on(select, 'change', function(){
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      } catch(e) {
        // Fallback for older browsers without URL constructor
        window.location.search = '?sort_by=' + encodeURIComponent(select.value);
      }
    });
  });

  /* Collection mobile filter drawer */
  var collFilters = V.$('[data-coll-filters]');
  if(collFilters){
    var collScrim = document.createElement('div');
    collScrim.className = 'coll-filters-scrim';
    collScrim.setAttribute('aria-hidden','true');
    document.body.appendChild(collScrim);
    // Dialog semantics are applied only while the panel is actually modal.
    // On desktop this element is a sticky sidebar beside the results; marking it
    // role="dialog" aria-modal="true" there would tell assistive tech the rest of
    // the page is inert, which is false. So the role goes on at open and comes
    // off at close, and the panel keeps its static aria-label in both modes.
    function openCollFilters(){
      collFilters.classList.add('is-open');
      collFilters.setAttribute('aria-hidden','false');
      collFilters.setAttribute('role','dialog');
      collFilters.setAttribute('aria-modal','true');
      collScrim.classList.add('is-open');
      document.body.classList.add('no-scroll');
      if(V.trapFocus) V.trapFocus(collFilters);
    }
    function closeCollFilters(){
      collFilters.classList.remove('is-open');
      collFilters.setAttribute('aria-hidden','true');
      collFilters.removeAttribute('role');
      collFilters.removeAttribute('aria-modal');
      collScrim.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      if(V.releaseFocus) V.releaseFocus(collFilters);
    }
    V.$$('[data-mobile-filter-open]').forEach(function(btn){ V.on(btn,'click',openCollFilters); });
    V.$$('[data-mobile-filter-close]').forEach(function(btn){ V.on(btn,'click',closeCollFilters); });
    V.on(collScrim, 'click', closeCollFilters);
    // Close on Escape (additive to existing global ESC handler)
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && collFilters.classList.contains('is-open')) closeCollFilters();
    });
  }
})();
